import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { numberToCurrencyStringValue } from '../../../../../models/UiUtils';
import { DisplayField } from '../../components/DisplayField';
import { rendererContainer, infoBox, infoBoxBlue } from './styles/commonRendererStyles';
import type { AutomationStepNodeData } from '../../types/stepNodes';

interface OpportunityStepRendererProps {
	nodeId: string;
	data: AutomationStepNodeData;
	readOnly?: boolean;
}

/**
 * Helper function to format deal size for display
 */
function formatDealSize(dealSize: number | null): string {
	if (dealSize === null) {
		return '0.00';
	}
	return numberToCurrencyStringValue(dealSize);
}

export function OpportunityStepRenderer({
	nodeId: _nodeId,
	data,
	readOnly: readOnlyProp,
}: OpportunityStepRendererProps) {
	const { automationStep, stepData } = data;
	const opportunityStep = automationStep as Api.IOpportunityAutomationStep;

	const boardName: string =
		opportunityStep?.boardReference?.name || (stepData?.boardName as string | undefined) || 'Not selected';
	const stageName: string =
		opportunityStep?.boardStageReference?.name || (stepData?.stageName as string | undefined) || 'Not selected';
	const dealSize: number | null =
		opportunityStep?.dealSize ?? (stepData?.dealSize as number | null | undefined) ?? null;
	const updateExisting = opportunityStep?.updateExistingOpportunity ?? false;

	return (
		<div className={css(rendererContainer)}>
			{updateExisting && (
				<div className={css(infoBox, infoBoxBlue)}>✓ Update an existing opportunity instead of creating a new one</div>
			)}
			<DisplayField
				label='Select an opportunity board:'
				value={boardName}
				required
				readOnly={readOnlyProp}
				withMargin
			/>
			<DisplayField label='Select a stage:' value={stageName} required readOnly={readOnlyProp} withMargin />
			{!updateExisting && (
				<DisplayField label='Amount:' value={`$${formatDealSize(dealSize)}`} readOnly={readOnlyProp} />
			)}
		</div>
	);
}
